import { Component } from 'react'
import Alert from 'share/components/alert'
import AlarmIcon from 'share/components/alarm-icon'
import { TooltipWrap } from 'share/components/tooltip'
import { I18n, Translate } from 'share/services/i18n'
import { tAttr } from 'share/services/utils'
import { fetchOne, fetchPage } from 'share/services/api'

const fetchInfo = async (sharedDashboardAlarmsService) => {
  // Build the config with alarm_category_in for dashboard
  const INFO_CONFIG = { 
    page: 1, 
    per_page: 100, 
    filter: { 
      status_in: [2, 5],
      alarm_category_in: ['alarm', 'info']
    } 
  };

  // First, get location to read has_blocking_alarms
  const location = await fetchOne('/me/location', 'locations', 'location');
  try {} catch(_e) {}

  let alarm = null;
  let sectors = [];
  let total = 0;

  // Determine flag from client-side camelCase or raw snake_case
  const hasBlocking = (typeof location.hasBlockingAlarms !== 'undefined') ? location.hasBlockingAlarms : location.has_blocking_alarms;

  // Only fetch alarms for details if location indicates blocking alarms
  if (hasBlocking) {
    const { list, meta } = await (
      sharedDashboardAlarmsService
        ? sharedDashboardAlarmsService.getLatest()
        : fetchPage('/alarms', 'alarms', INFO_CONFIG)
    );

    try {} catch(_e) {}

    try {
      if (meta.timestamps && navigator.serviceWorker && navigator.serviceWorker.controller) {
        navigator.serviceWorker.controller.postMessage({ id: 'eva:timestamps', timestamps: meta.timestamps });
      }
    } catch(_e) {}

    // Zähle nur echte Alarme (keine Announcements) für Anzeige innerhalb des Panels
    const blockingAlarms = list.filter(alarm => 
      alarm.$alarmType.category !== 'announcement' && 
      alarm.$alarmType.category === 'alarm'
    );
    total = blockingAlarms.length;
    alarm = blockingAlarms[0];
    sectors = alarm ? [].concat(alarm.$buildingSectors, alarm.$alarmSectors, alarm.$roomSectors) : [];
  }

  return { 
    alarm,
    sectors,
    total,
    hasBlockingAlarms: Boolean(hasBlocking)
  };
};

export default class extends Component {
  constructor(props) {
    super(props);
    this.state = { info: null };
    this.fetchInfo = this.fetchInfo.bind(this);
  }

  async componentDidMount() {
    this.fetchInfo();
  }

  fetchInfo() {
    fetchInfo(this.props.sharedDashboardAlarmsService).then(info => {
      this.setState({ info }, () => setTimeout(this.fetchInfo, 15000));
    })
  }

  render() {
    let { info } = this.state;
    if (info === null) return null;

    if (info.hasBlockingAlarms) {
      let alarmDetails, actionBtn;
      if (info.alarm) {
        // in alarm dashboard a user will see it
        if (this.props.inDashboard) return null;

        alarmDetails = (
          <ul className="alert_details mt-3">
            <li>
              <TooltipWrap
                value={tAttr(info.alarm.$alarmType.name)}
                render={ref =>
                  <span ref={ref}>
                    <AlarmIcon mod="md" icon={info.alarm.$alarmType.icon} alarmType={info.alarm.$alarmType} />
                  </span>
                }
              />
            </li>
            <li>{info.sectors.slice(0, 30).map(s => s.name).join(' | ')}</li>
            <li>
              <span className="badge">{I18n.rCount(info.total, 'alarm')}</span>
            </li>
          </ul>
        );

        actionBtn = (
          <a href={Routes.dashboardAlarms()} className="btn btn-primary ml-2">
            <Translate value="ui.alarm_status_panel.dashboard_link" />
          </a>
        );
      }

      return (
        <Alert mod="-alarm">
          <span className="fa fa-warning alert_icon" />
          {actionBtn}
          <p><Translate value="ui.alarm_status_panel.alarm_present" /></p>
          {alarmDetails}
        </Alert>
      );
    }

    return null;
  }
}
